module.exports = __webpack_public_path__ + "static/media/email.6bdf0d39.svg";